<div class="what-links-here-margin-main" *ngIf="outcomeStatus">
  <article class="specialcase-header" [innerHTML]="what_links_header"></article>
  <article class="mt-2 what-links-here-Info" [innerHTML]="what_links_body"></article>
  <div class="link-group">
    <div class="link-heading" [innerHTML]="links_to"></div>
    <div class="link-paragraph" *ngFor="let Records of linkRecord">
      <div>
        <span class="link-topic">{{Records.group}}</span>
      </div>
      <div class="link-body">
        <div class="mt_1" *ngFor="let obj of Records.source">
          <div *ngIf="obj.isGlossary">
            <a class="cursor-pointer display-list" id="{{obj.sourceParagraphId}}" (click)="OpenInlineGlossary($event)">
              <span *ngIf="obj.sourceLevelOne=='gasb_glossaries'" id="{{obj.sourceParagraphId}}">
                <span *ngIf="obj.sourceLevelTwo=='COD'">Codification</span>
                <span *ngIf="obj.sourceLevelTwo=='OP'">Original Pronouncements</span>
                <span *ngIf="obj.sourceLevelTwo=='CIG'">Comprehensive Implementation Guide</span>
                <span *ngIf="obj.sourceLevelTwo!='COD' && obj.sourceLevelTwo!='OP' && obj.sourceLevelTwo!='CIG'">{{obj.sourceLevelTwo}}</span>
                <span *ngIf="obj.sourceLevelThree!=obj.sourceParaNumber"> > {{obj.sourceLevelThree}} > {{obj.sourceParaNumber}}</span>
                <span *ngIf="obj.sourceLevelThree==obj.sourceParaNumber"> > {{obj.sourceParaNumber}}</span>
              </span>
              <span *ngIf="obj.sourceLevelOne!='gasb_glossaries'" id="{{obj.sourceParagraphId}}">{{obj.sourceLevelOne}} > {{obj.sourceLevelTwo}} > {{obj.sourceParaNumber}}</span>
            </a>
          </div>
          <div *ngIf="!obj.isGlossary">
          <a class="cursor-pointer display-list" (click)="gotoContent(obj,$event)" (contextmenu)="onRightClick(obj,$event)">
            <span [innerHtml]="obj.sourceLevelOne"></span><span *ngIf="obj.sourceLevelTwo">&nbsp;>&nbsp;</span>
            <span [innerHtml]="obj.sourceLevelTwo"></span><span *ngIf="obj.sourceLevelThree">&nbsp;>&nbsp;</span>
            <span [innerHtml]="obj.sourceLevelThree"></span><span *ngIf="obj.sourceLevelFour">&nbsp;>&nbsp;</span>
            <span [innerHtml]="obj.sourceLevelFour"></span> <span *ngIf="obj.sourceLevelFive && obj.sourceParaNumber!=obj.sourceLevelFive">&nbsp;>&nbsp;</span>
            <span *ngIf="obj.sourceParaNumber==obj.sourceLevelFive">
              <span *ngIf="(obj.sourceParaType=='FOOTNOTE') && obj.sourceParaNumber"> > fn</span>
              <span *ngIf="(obj.sourceParaType=='PARA' || obj.sourceParaType=='p-norm') && obj.sourceParaNumber && obj.sourceLevelOne=='Codification'"> > </span>
              <span *ngIf="(obj.sourceParaType=='PARA' || obj.sourceParaType=='p-norm') && obj.sourceParaNumber && obj.sourceLevelOne!='Codification'"> > ¶</span>
              <span *ngIf="(obj.sourceParaType=='QUESTION') && obj.sourceParaNumber"> > Q</span>
            </span>
            <span [innerHtml]="obj.sourceLevelFive"></span>
            <span *ngIf="obj.sourceParaNumber!=obj.sourceLevelFive">
              <span *ngIf="(obj.sourceParaType=='FOOTNOTE') && obj.sourceParaNumber"> > fn</span>
              <span *ngIf="(obj.sourceParaType=='PARA' || obj.sourceParaType=='p-norm') && obj.sourceParaNumber && obj.sourceLevelOne=='Codification'"> > </span>
              <span *ngIf="(obj.sourceParaType=='PARA' || obj.sourceParaType=='p-norm') && obj.sourceParaNumber && obj.sourceLevelOne!='Codification'"> > ¶</span>
              <span *ngIf="(obj.sourceParaType=='QUESTION') && obj.sourceParaNumber"> > Q</span>
            </span>

            <span *ngIf="obj.sourceParaNumber!=obj.sourceLevelFive" [innerHtml]="obj.sourceParaNumber"></span>
          </a>
          </div>
        </div>
        </div>
      </div>
      <div class="font-16 link-heading mt-2" *ngIf="what_links_source.length==0">
        No links available
      </div>
    </div>
</div>

<div class="what-links-here-margin-main font-2" *ngIf="invalidbreadcrumb">
Null
</div>
